import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { clientI18n } from '../ClientI18n.ts';
import { DialogManagerProvider } from '@colonist/ui';
export const mountUIReactComponent = (containerId, Component)=>{
    const container = document.getElementById(containerId);
    if (!container) throw new Error(`Container with id ${containerId} not found`);
    const root = createRoot(container);
    return {
        render: (props)=>{
            root.render(/*#__PURE__*/ React.createElement(I18nextProvider, {
                i18n: clientI18n.instance
            }, /*#__PURE__*/ React.createElement(DialogManagerProvider, null, /*#__PURE__*/ React.createElement(Component, props))));
        },
        unmount: ()=>root.unmount()
    };
};
